import bg from '../assets/bg.png';
import logo from '../assets/logo.png';
import overlaybg from '../assets/overlaybg.png';
import welcome from '../assets/welcome.png';

export default {
  bg,
  logo,
  overlaybg,
  welcome,
};
